module.exports = __webpack_public_path__ + "img/LSG_Rect_512.3a07363f.jpg";